import React from 'react';
import SEO from './components/SEO';
import Breadcrumb from './components/Breadcrumb';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPage() {
  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: 'プライバシーポリシー', path: '/privacy' }
  ];

  return (
    <div className="privacy-page">
      <SEO page="privacy" />

      <section className="ds-page-hero">
        <div className="container">
          <Breadcrumb items={breadcrumbItems} />
          <p className="ds-eyebrow">PRIVACY POLICY</p>
          <h1 className="ds-h1">プライバシーポリシー</h1>
          <p className="ds-lead">
            PortRay株式会社（以下「当社」といいます）は、お客様の個人情報の保護を重要な責務と考え、以下のとおりプライバシーポリシーを定め、適切な取り扱いに努めます。
          </p>
        </div>
      </section>

      <section className="ds-section">
        <div className="container">
          <div className="privacy-body">
            <div className="privacy-section">
              <h2 className="ds-h3">1. 個人情報の定義</h2>
              <p>
                本ポリシーにおいて「個人情報」とは、個人情報保護法に定める個人情報を指し、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、メールアドレスその他の記述等により特定の個人を識別できるものをいいます。
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="ds-h3">2. 個人情報の収集方法</h2>
              <p>
                当社は、お問い合わせフォーム、資料ダウンロード、サービスのお申し込み等の際に、氏名、会社名、電話番号、メールアドレス等の個人情報をお伺いすることがあります。
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="ds-h3">3. 個人情報の利用目的</h2>
              <p>当社が個人情報を収集・利用する目的は以下のとおりです。</p>
              <ul>
                <li>当社サービスの提供・運営のため</li>
                <li>お問い合わせに対する回答のため</li>
                <li>資料の送付・ご案内のため</li>
                <li>メンテナンス、重要なお知らせなどの連絡のため</li>
                <li>利用規約に違反した利用者への対応のため</li>
                <li>当社サービスの改善・新サービスの開発のため</li>
                <li>上記の利用目的に付随する目的のため</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2 className="ds-h3">4. 個人情報の第三者提供</h2>
              <p>
                当社は、以下の場合を除き、あらかじめご本人の同意を得ることなく第三者に個人情報を提供することはありません。
              </p>
              <ul>
                <li>法令に基づく場合</li>
                <li>人の生命、身体または財産の保護のために必要がある場合</li>
                <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
                <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
              </ul>
            </div>

            <div className="privacy-section">
              <h2 className="ds-h3">5. 個人情報の安全管理</h2>
              <p>
                当社は、個人情報の正確性及び安全性を確保するために、セキュリティに十分な対策を講じ、個人情報の漏洩、改ざん、不正アクセス等の防止に努めます。
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="ds-h3">6. 個人情報の開示・訂正・削除</h2>
              <p>
                ご本人から個人情報の開示、訂正、削除、利用停止等のご請求があった場合、ご本人であることを確認した上で、合理的な期間及び範囲で対応いたします。ご請求は下記のお問い合わせ窓口までご連絡ください。
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="ds-h3">7. Cookie（クッキー）の使用について</h2>
              <p>
                当社のウェブサイトでは、サービスの利便性向上やアクセス状況の分析のためにCookieを使用する場合があります。ブラウザの設定によりCookieの受け入れを拒否することが可能ですが、その場合一部のサービスが正常に動作しないことがあります。
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="ds-h3">8. プライバシーポリシーの変更</h2>
              <p>
                本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく変更することがあります。変更後のプライバシーポリシーは、本ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </div>

            <div className="privacy-section">
              <h2 className="ds-h3">9. お問い合わせ窓口</h2>
              <p>本ポリシーに関するお問い合わせは、以下の窓口までご連絡ください。</p>
              <div className="ds-card privacy-contact">
                <p>PortRay株式会社</p>
                <p>〒107-0061 東京都港区北青山2丁目12番8号 BIZSMART</p>
              </div>
            </div>

            <p className="privacy-date">制定日：<span className="ds-num">2019年3月1日</span></p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PrivacyPolicyPage;
